import React, { Component } from "react";
import { Box, Flex, Spacer, HStack, Card, CardBody, Text, SimpleGrid } from '@chakra-ui/react';
import { DateTime } from "luxon";
import LogHealthCard from "./LogHealthCard.jsx";
import HealthCard from "../../../../components/Healthcard.jsx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeartPulse, faArrowCircleDown } from "@fortawesome/free-solid-svg-icons";

import HealthFunctions from "./HealthFunctions.js";

import "../../../../assets/css/healthfolder.css";

export default class HealthFolder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            overallHealth: "Healthy",
            lastRefreshed: ""
        }
        this.cardHealth = {
            nabcshipments: "Healthy",
            nabcinv: "Healthy",
            gvabatch: "Healthy",
            mraCatalogRefresh: "Healthy"
        };
        this.toggleFull = this.toggleFull.bind(this)
        this.onCardHealthUpdate = this.onCardHealthUpdate.bind(this);
    }

    onCardHealthUpdate(cardId, health) {
        var newOverallHealth = "Healthy";
        this.cardHealth[cardId] = health;
        Object.keys(this.cardHealth).forEach(key => {
            if (this.cardHealth[key] === "Problem") {
                newOverallHealth = "Problem";
            }
            else if ((this.cardHealth[key] === "Warning") && (newOverallHealth !== "Problem")) {
                newOverallHealth = "Warning";
            }
        })

        this.setState({
            overallHealth: newOverallHealth,
            lastRefreshed: DateTime.now().setZone('America/Los_Angeles').toLocaleString(DateTime.DATETIME_SHORT)
        });
    }


    toggleFull() {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        var hide = "none";
        if (this.state.open) {
            hide = "block"
        } else {
            hide = "none"
        }


        return (


            <div style={{ width: "100%" }}>
                <Box p="4">
                    <Card
                        overflow='hidden'
                        background='white'
                    >
                        <CardBody>
                            <HStack justify="center">
                                <Text className="lastCheckedText" style={{ fontStyle: "italic", color: "#898787bd" }}>Last Checked: {this.state.lastRefreshed}</Text>
                                <Spacer style={{ margin: "-10%" }} />

                                <FontAwesomeIcon icon={faHeartPulse} color={HealthFunctions.getHealthColor(this.state.overallHealth)} size="2x" />
                                <Text>{this.state.overallHealth}</Text>

                                <Spacer />
                                <FontAwesomeIcon icon={faArrowCircleDown} color="grey" onClick={() => this.toggleFull()} />
                            </HStack>

                        </CardBody>
                    </Card>
                </Box>

                {/* <Flex wrap='wrap' display={hide}> */}
                <SimpleGrid columns={[1, 2, 3, 4]}>
                    <Box p='4' display={hide}>
                        < LogHealthCard
                            userSession={this.props.userSession}
                            onCardHealthUpdate={this.onCardHealthUpdate}
                            title="NABC Shipments"
                            eventType="nabcshipments"
                        />
                    </Box>
                    
                    <Box p='4' display={hide}>
                        < LogHealthCard
                            userSession={this.props.userSession}
                            onCardHealthUpdate={this.onCardHealthUpdate}
                            title="NABC Inventory"
                            eventType="nabcinv"
                        />
                    </Box>
                  
                    <Box p='4' display={hide}>
                        < LogHealthCard
                            userSession={this.props.userSession}
                            onCardHealthUpdate={this.onCardHealthUpdate}
                            title="GVA"
                            eventType="gvabatch"
                        />
                    </Box>
                 
                    <Box p='4' display={hide}>
                        < LogHealthCard
                            userSession={this.props.userSession}
                            onCardHealthUpdate={this.onCardHealthUpdate}
                            title="MRA Catalogs"
                            eventType="mraCatalogRefresh"
                        />
                    </Box>
                </SimpleGrid>
                {/* </Flex> */}
            </div>
        )

    }
}